import { render, staticRenderFns } from "./GridItemLayoutConfig.vue?vue&type=template&id=71024c67&"
import script from "./GridItemLayoutConfig.vue?vue&type=script&lang=js&"
export * from "./GridItemLayoutConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports